let questions = document.querySelectorAll(".questions");

questions.forEach(question => {
  question.addEventListener("click", event => {
    const active = document.querySelector(".questions.active");
    if (active && active !== question) {
      active.classList.toggle("active");
      active.nextElementSibling.style.maxHeight = 0;
    }

    question.classList.toggle("active");
    const answers = question.nextElementSibling;

    if (question.classList.contains("active")) {
      answers.style.maxHeight = answers.scrollHeight + "px";
    } else {
      answers.style.maxHeight = 0;
    }
  });
});

// 👇 Open first accordion by default
if (questions.length > 0) {
  questions[0].classList.add("active");
  const firstAnswer = questions[0].nextElementSibling;
  firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
}




